export function parseError(error) {
  const code = error?.response?.data?.code;
  const fallbackMessage = 'Algo deu errado. Tente novamente mais tarde.';
  const backendMessage = error?.response?.data?.message;
  const legacyMessage = error?.response?.data?.error;

  const messages = {
    VALIDATION_ERROR: 'Há informações inválidas no formulário.',
    NOT_FOUND: 'Recurso não encontrado.',
    ALREADY_EXISTS: 'Este item já está cadastrado.',
    UNAUTHORIZED: 'E-mail ou senha incorretos.',
    TOO_MANY_REQUESTS: 'Muitas tentativas. Tente novamente mais tarde.',
    FORBIDDEN: 'Você não tem permissão para essa ação.',
    INVALID_INPUT: 'Dados fornecidos estão incorretos.',
    CONFLICT: 'Conflito nos dados enviados.',
    TOKEN_EXPIRED: 'Sua sessão expirou. Faça login novamente.',
    INVALID_TOKEN: 'Token inválido. Faça login novamente.',
    EMAIL_IN_USE: 'Este e-mail já está sendo utilizado.',
    INVALID_PASSWORD: 'Senha incorreta.',
    INTERNAL_SERVER_ERROR: 'Erro interno. Tente novamente mais tarde.',
    SERVER_STARTUP_FAILED: 'Erro ao iniciar o servidor. Tente mais tarde.',

    // fallback extra
    NETWORK_ERROR: 'Problema de conexão. Verifique sua internet.',
  };

  // Falha de conexão (sem resposta do backend)
  if (!error.response) {
    return messages['NETWORK_ERROR'];
  }

  // Prioridade para mensagem amigável enviada pelo backend
  if (backendMessage) {
    return backendMessage;
  }

  // Compatibilidade com payload legado
  if (legacyMessage) {
    return legacyMessage;
  }

  // Código conhecido vindo do backend
  if (code && messages[code]) {
    return messages[code];
  }

  return error?.message || fallbackMessage;
}
